import { Injectable } from "@angular/core";
import { ChatOpenStore } from "app/chat/open";
import { filter, map, Observable, take, tap } from "rxjs";
import { AppHostService } from "./app-host.service";

/**
 * This service handles the events sent by external clients via the loader.
 *
 * The stage listener opens the chat when an external client requests stage=open.
 */
@Injectable({
  providedIn: "root",
})
export class ExternalEventsService {
  constructor(
    private readonly appHost: AppHostService,
    private readonly chatOpenStore: ChatOpenStore
  ) {}

  /**
   * Observable that listens to stage=open and opens the chat once.
   */
  public get stage$(): Observable<void> {
    return this.appHost.stage$.pipe(
      filter((stage) => stage === "open"),
      take(1),
      tap(() => this.chatOpenStore.open()),
      map(() => undefined)
    );
  }

  /** Returns the listener for external stage events. */
  public get allListeners$(): Observable<void> {
    return this.stage$;
  }
}
